import { useQuery, QueryHookOptions } from '@apollo/client';

import { LIST_AUTOMATIONS_QUERY } from '@frontend/app/queries';
import {
  ListAutomations,
  ListAutomationsVariables,
} from '@frontend/app/queries/types/ListAutomations';
import { useApolloClientForAspirex } from './useApolloClientForAspirex';

type TOptions = QueryHookOptions<ListAutomations, ListAutomationsVariables>;

export const useListOfferEmailAutomationsQuery = (options: TOptions = {}) => {
  const aspirexClient = useApolloClientForAspirex();

  return useQuery<ListAutomations, ListAutomationsVariables>(
    LIST_AUTOMATIONS_QUERY,
    {
      ...options,
      client: aspirexClient,
    }
  );
};
